(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["laboftrades-remote-connect"] = factory();
	else
		root["laboftrades-remote-connect"] = factory();
})(globalThis, () => {
return 